import { track } from './umami.ts';
import { getAndroidPlayStoreWebLink, getAppStoreWebLink, getiOSAppStoreWebLink } from './utils.ts';

import AppStoreButton from './assets/app_store_download.svg';
import PlayStoreButton from './assets/play_store_download.svg';

export function AppStoreButtonLink() {
    return (
        <a
            href={getiOSAppStoreWebLink()}
            className='app-store-button'
            aria-label='Download Triplit on the App Store'
            onClick={() => {
                track('app_store_link_clicked_promo_official_button');
            }}>
            <AppStoreButton />
        </a>
    );
}

export function PlayStoreButtonLink() {
    return (
        <a
            href={getAndroidPlayStoreWebLink()}
            className='play-store-button'
            aria-label='Download Triplit on the Play Store'
            onClick={() => {
                track('play_store_link_clicked_promo_official_button');
            }}>
            <PlayStoreButton />
        </a>
    );
}
